// src/components/AccessControl/InterdictedModal.tsx
// ✅ MODAL PARA CONTEÚDOS EM MANUTENÇÃO

import React from 'react';
import { Construction, Clock } from 'lucide-react';
import './InterdictedModal.css';

interface InterdictedModalProps {
    isOpen: boolean;
    onClose: () => void;
    entityType: 'cycle' | 'deck' | 'subdeck' | 'tab' | 'space';
    entityName?: string;
    /**
     * 'restricted' = "Restringir temporariamente" — função independente de
     * interdição ("em obras"). Troca ícone/título/cor pra não confundir as
     * duas (não usa a palavra "interditado" nem a mensagem padrão de
     * interdição) e mostra a mensagem definida pelo admin em `customMessage`.
     * Omitido (ou 'interdicted') preserva o comportamento de sempre.
     */
    variant?: 'interdicted' | 'restricted';
    /** Mensagem definida pelo admin — usada só quando variant === 'restricted'. */
    customMessage?: string;
}

const InterdictedModal: React.FC<InterdictedModalProps> = ({
    isOpen,
    onClose,
    entityType,
    entityName,
    variant = 'interdicted',
    customMessage,
}) => {
    if (!isOpen) return null;

    const isRestricted = variant === 'restricted';

    const getEntityLabel = () => {
        switch (entityType) {
            case 'cycle':
                return 'Este campo de estudo';
            case 'deck':
                return 'Este deck';
            case 'subdeck':
                return 'Este conteúdo';
            case 'tab':  // ✅ NOVO
                return 'Esta sessão';
            case 'space':
                return 'Este campo de estudo';
            default:
                return 'Este conteúdo';
        }
    };

    const getMessage = () => {
        const label = getEntityLabel();
        return `${label} está em obras e passando por melhorias.`;
    };

    return (
        <div className="interdicted-modal-overlay" onClick={onClose}>
            <div className="interdicted-modal" onClick={(e) => e.stopPropagation()}>
                <button
                    className="interdicted-modal-close"
                    onClick={onClose}
                    aria-label="Fechar"
                >
                    ✕
                </button>

                <div className="interdicted-modal-icon">
                    {isRestricted
                        ? <Clock size={64} strokeWidth={1.5} color="#4A90D9" />
                        : <Construction size={64} strokeWidth={1.5} color="#D4B35D" />}
                </div>

                <h2 className="interdicted-modal-title">
                    {isRestricted ? 'Conteúdo temporariamente indisponível' : 'Em Obras'}
                </h2>

                {entityName && (
                    <p className={`interdicted-modal-entity${isRestricted ? ' interdicted-modal-entity--restricted' : ''}`}>
                        {entityName}
                    </p>
                )}

                <p className="interdicted-modal-message">
                    {isRestricted ? (customMessage || 'Este conteúdo está temporariamente indisponível.') : getMessage()}
                </p>

                {!isRestricted && (
                    <p className="interdicted-modal-submessage">
                        Estamos trabalhando para trazer a melhor experiência possível.
                    </p>
                )}

                <div className="interdicted-modal-footer">
                    <button
                        className="interdicted-modal-btn"
                        onClick={onClose}
                    >
                        Entendi
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InterdictedModal;